import { render, staticRenderFns } from "./advertisementone.vue?vue&type=template&id=69f8298a&"
import script from "./advertisementone.vue?vue&type=script&lang=js&"
export * from "./advertisementone.vue?vue&type=script&lang=js&"
import style0 from "./advertisementone.vue?vue&type=style&index=0&id=69f8298a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports